export default __webpack_public_path__ + "static/media/onboardingAside.15c205b4.png";